<template>
  <div class="main">
    <van-nav-bar
      title="中专 中职 技校"
      left-text="首页"
      left-arrow
      @click-left="onClickLeft"
    />
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item>
         <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
            <van-image
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/chatpage2/banner.jpg"
            />
          </a>
        </van-swipe-item>
        <van-swipe-item>
         <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
            <van-image
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/chatpage2/banner1.jpg"
            />
          </a>
        </van-swipe-item>
      </van-swipe>
   
    <div class="menu">
      <div class="menu-one">
        <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
          <div class="menu-up">
            <img
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/chatpage2/m1.png"
            />
          </div>
          <div class="menu-down">西点学校</div>
        </a>
      </div>
      <div class="menu-one">
        <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
          <div class="menu-up">
            <img
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/chatpage2/m2.png"
            />
          </div>
          <div class="menu-down">西点学校招生简章</div>
        </a>
      </div>
      <div class="menu-one">
        <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
          <div class="menu-up">
            <img
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/chatpage2/m3.png"
            />
          </div>
          <div class="menu-down">招生计划</div>
        </a>
      </div>
      <div class="menu-one">
        <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
          <div class="menu-up">
            <img
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/chatpage2/m4.png"
            />
          </div>
          <div class="menu-down">考生网上报名</div>
        </a>
      </div>
      <div class="menu-one">
        <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
          <div class="menu-up">
            <img
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/chatpage2/m5.png"
            />
          </div>
          <div class="menu-down">报名条件</div>
        </a>
      </div>
      <div class="menu-one">
        <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
          <div class="menu-up">
            <img
              src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/chatpage2/m6.png"
            />
          </div>
          <div class="menu-down">专业咨询</div>
        </a>
      </div>
    </div>
    <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/chatpage2/p1.jpg"
      />
    </a>

    <h2 style="text-align: center">热门问题</h2>
    <div class="hot">
      <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
        <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/chatpage2/p2.jpg"
        />
      </a>
    </div>
    <div class="chat" onclick="ydtopenchat();return false;">
      <div class="chat-title">欧米奇顾老师</div>
      <div class="chat-one">
        <div class="chat-head" v-show="show1">
          <img
            :src="head"
            style="width: 45px; height: 45px; border-radius: 5px; float: left"
          />
          <div class="chat-words">您好，请问有什么可以帮到您？</div>
        </div>
      </div>

      <div class="chat-one">
        <div class="chat-head" v-show="show2">
          <img
            :src="head"
            style="width: 45px; height: 45px; border-radius: 5px; float: left"
          />
          <div class="chat-words">您是想了解专业课程还是预约到校参观？</div>
        </div>
      </div>
      <div class="chat-one">
        <div class="chat-head" v-show="show3">
          <img
            :src="head"
            style="width: 45px; height: 45px; border-radius: 5px; float: left"
          />
          <div class="chat-words" style="width: 100px">
            <img :src="talk" class="chat-talk" alt="" />
            <div class="chat-num">5''</div>
          </div>
          <div class="red-redius"></div>
        </div>
      </div>
      <div style="width: 100%; height: 10px"></div>
      <div class="chat-one">
        <div class="chat-head">
          <div class="chat-input">请输入您的问题...</div>
          <div class="chat-submit">发送</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      head:
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/chatpage2/head.jpg",
      talk:
        "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/chatpage2/talk.png",
      redius: "",
      show1: false,
      show2: false,
      show3: false,
    };
  },
  created: function () {
    this.timer = setInterval(this.show, 6500);
  },
  methods: {
    onClickLeft() {
      this.$router.push("/");
    },
    show() {
      this.show1 = false;
      this.show2 = false;
      this.show3 = false;
      setTimeout(() => {
        this.show1 = true;
      }, 500);
      setTimeout(() => {
        this.show2 = true;
      }, 2500);
      setTimeout(() => {
        this.show3 = true;
      }, 5000);
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="less" scoped>
/deep/ .ivu-btn-success {
  background-color: #fa3f0f;
  border: 1px solid #fa3f0f;
}
.hot-words {
  float: left;
  width: 60%;
  line-height: 30px;
  font-size: 15px;
  font-weight: 600;
  height: 30px;
}
.hot-one {
  padding: 10px 0;
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #682b19;
}

.button {
  padding: 10px;
}
/deep/ .van-button--info {
  color: #000;
  width: 48%;
  margin-right: 2%;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  border: 1px solid #000;
}
.menu-down {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
}
.menu-up {
  width: 70px;
  height: 70px;
  margin: auto;
  text-align: center;
  img {
    width: 100%;
    height: 100%;
  }
}
.menu {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 15px;
}
.menu-one {
  width: 30%;
  height: 100px;
  margin-bottom: 10px;
}
/deep/ .van-nav-bar .van-icon {
  color: #fff;
}
/deep/ .van-nav-bar__text {
  color: #fff;
}
/deep/ .van-nav-bar__title {
  color: #fff;
}
/deep/ .van-nav-bar {
  background-color: #aa6b01;
}

.chat {
  width: 100%;
  height: 330px;
  padding: 10px 0 10px 0;
  background: #eee;
}

.chat-one {
  width: 96%;
  height: 45px;
  padding: 0 2%;
  margin-bottom: 20px;
}

.chat-title {
  text-align: center;
  width: 100%;
  height: 30px;
  border-bottom: 1px solid #fff;
  margin-bottom: 30px;
}

.chat-words {
  margin-left: 10px;
  padding: 0 5px 0 10px;
  height: 45px;
  background: #fff;
  text-align: center;
  line-height: 45px;
  float: left;
  border-radius: 5px;
  font-size: 14px;
}

.chat-input {
  padding: 0 5px 0 10px;
  height: 40px;
  width: 68%;
  background: #fff;
  text-align: left;
  line-height: 40px;
  float: left;
  border-radius: 5px;
}

.chat-submit {
  padding: 0 5px 0 10px;
  height: 40px;
  width: 20%;
  color: #fff;
  background: #81dfaa;
  text-align: center;
  margin-left: 3%;
  line-height: 40px;
  float: left;
  border-radius: 5px;
}

.chat-talk {
  width: 22px;
  margin-top: 11px;
  height: 22px;
  float: left;
}

.chat-num {
  height: 45px;
  line-height: 45px;
  margin-left: 10px;
  float: left;
}

.red-redius {
  width: 7px;
  height: 7px;
  background: red;
  border-radius: 50%;
  float: left;
  margin-top: 18px;
  margin-left: 10px;
}
</style>